import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';
import apiClient from '../services/api';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id') || searchParams.get('sessionId');

    if (sessionId) {
      setIsConfirming(true);
      apiClient
        .post(`/Subscription/confirm?sessionId=${sessionId}`)
        .catch(() => {
          // Ignore confirm errors — subscription may already be processed by webhook
        })
        .finally(() => setIsConfirming(false));
    }

    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen gradient-hero flex items-center justify-center px-4">
      <Card className="max-w-md w-full animate-scale-in">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            {isConfirming ? (
              <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
                <Loader2 className="w-12 h-12 text-primary animate-spin" />
              </div>
            ) : (
              <div className="w-20 h-20 rounded-full bg-success/10 flex items-center justify-center">
                <CheckCircle className="w-12 h-12 text-success" />
              </div>
            )}
          </div>
          <CardTitle className="text-2xl font-display">Payment Successful!</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            {isConfirming
              ? 'Activating your subscription...'
              : 'Your subscription has been activated successfully.'}
          </p>
          <p className="text-sm text-muted-foreground">
            You will be redirected to your dashboard in a few seconds...
          </p>
          <Button onClick={() => navigate('/dashboard')} className="w-full" disabled={isConfirming}>
            Go to Dashboard Now
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
